export default __webpack_public_path__ + "static/media/Flyer-04.99489b31.jpg";